import * as ACTION_TYPES from '../types';

let initialState = {
  serviceFirmList: [],
  serviceFirm: {}
}

export default (state = initialState, action) => {
    switch (action.type) {

      case ACTION_TYPES.GET_SERVICEFIRMS:
        return {...state, serviceFirmList: action.data };

      case ACTION_TYPES.DELETE_SERVICEFIRM:
        let newList = state.serviceFirmList.filter(serviceFirm => serviceFirm._id !== action.id);
        return {...state, serviceFirmList: newList };
      
      case ACTION_TYPES.GET_SERVICEFIRM_BY_ID:
        return {...state, serviceFirm: action.data};

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_SERVICEFIRMS:
        return {...state, serviceFirmList: []};

      default:
        return state;
    }
  };